import Api from 'lib/api';
import {
  ADD_LOCATION,
  GET_LOCATIONS,
  REMOVE_LOCATION,
  MODIFY_LOCATION,
  UPDATE_LOCATIONS,
} from 'locations/constants';

export const getLocations = (companyId, subcompanyId) => ({
  type: GET_LOCATIONS,
  payload: Api.locations.get(companyId, subcompanyId),
});

export const removeLocation = (locationId) => ({
  type: REMOVE_LOCATION,
  payload: locationId,
});

export const addLocation = (parentId) => ({
  type: ADD_LOCATION,
  payload: parentId,
});

export const modifyLocation = (locationId, payload) => ({
  type: MODIFY_LOCATION,
  meta: { id: locationId },
  payload: payload,
});

export const updateLocations = (companyId, subcompanyId, payload) => ({
  type: UPDATE_LOCATIONS,
  payload: Api.locations.update(companyId, subcompanyId, payload),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/actions/locations_actions.js